import React from 'react';
import { Link } from 'react-router-dom';
import { about } from '../../portfolio';

const About = () => {
  const firstName = about.name.split(' ')[0];

  return (
    <>
      <div className="about-masonry">
        <div className="about-img about-img-square">
          <img src="/images/roshanimage2.jpg" alt="Manish Portrait" />
        </div>
        <div className="about-img about-img-tall">
          <img src="/images/roshanimage1.jpg" alt="Mountains" />
        </div>
        <div className="about-img about-img-wide">
          <img src="/images/roshanimage3.jpg" alt="Cycling" />
        </div>
      </div>

      <div className="about-content">
        <h1>Hi again, I'm {firstName}!</h1>
        <p>{about.description}</p>
        
        <p>I specialize in <strong>{about.role}</strong> and love to go deep dive into how things work, down to the bit levels and build an understanding from bottom to the top.</p>
                
        <p style={{ marginTop: '32px' }}>If you want to chat, feel free to reach out.</p>

        <footer className="footer" style={{ borderTop: '1px solid var(--border)', marginTop: '80px', paddingTop: '32px' }}>
          <div className="footer-socials">
            {about.social.tweet && <a href={about.social.tweet}>Twitter</a>}
            {about.social.github && <a href={about.social.github}>GitHub</a>}
            {about.social.linkedin && <a href={about.social.linkedin}>LinkedIn</a>}
          </div>
          <div>End of line.</div>
        </footer>
      </div>
    </>
  );
};

export default About;
